<template>
  <div class="dictindex">
    <el-card class="box-card">
      <!-- card header -->
      <div slot="header" class="clearfix">
        <span>技术与案例列表</span>
        <el-button
          class="tz-r tz-create-btn"
          type="primary"
          round
          @click="jump('/qualificationses/create')"
          >创建技术与案例</el-button
        >
      </div>
      <!-- card header -->

      <!-- card content -->
      <!-- 筛选 -->
      <el-row>
        <el-col :span="5">
          <el-input
            placeholder="请输入标题"
            v-model="queryParams.title"
            clearable
            class="input-with-select"
          >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="dictSearch"
            ></el-button>
          </el-input>
        </el-col>
        <el-col :span="4">
          <el-select
            v-model="queryParams.type"
            placeholder="类型"
            @change="radioChange($event, 'type')"
            clearable
          >
            <el-option
              v-for="item in typeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select
            v-model="queryParams.pushMp"
            placeholder="是否推送公众号"
            @change="radioChange($event, 'pushMp')"
            clearable
          >
            <el-option
              v-for="item in radioOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select
            v-model="queryParams.pushMpFlag"
            placeholder="是否启用公众号"
            @change="radioChange($event, 'pushMpFlag')"
            clearable
          >
            <el-option
              v-for="item in radioOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>

        <el-col :span="4">
          <el-select
            v-model="queryParams.pushOfficialWebsite"
            placeholder="是否推官网"
            @change="radioChange($event, 'pushOfficialWebsite')"
            clearable
          >
            <el-option
              v-for="item in radioOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select
            v-model="queryParams.pushOfficialWebsiteFlag"
            placeholder="是否启用官网"
            @change="radioChange($event, 'pushOfficialWebsiteFlag')"
            clearable
          >
            <el-option
              v-for="item in radioOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <!-- 筛选 -->

      <!-- 表格 -->
      <TzTable :tableData="dictList" :columns="columns" />
      <!-- 表格 -->

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryParams.pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
      <!-- 分页 -->
      <!-- card content -->
    </el-card>
    <!-- card -->

    <!-- 编辑弹框 -->
    <!-- <Edit
      :state="editState"
      @close="editState = false"
      :row="editUnit"
      @confirm="changeDict"
    /> -->
    <!-- 编辑弹框 end -->
  </div>
</template>

<script>
import { quaList, deleteQua } from '@/api/qualificationses'
import TzTable from '@/components/tz-table/Index.vue'
// import Edit from './components/Edit'
export default {
  components: {
    TzTable
    // Edit
  },
  data() {
    return {
      page: 1, //当前页
      size: '10',
      total: 100,
      dictTypeValue: '',
      editState: false,
      editUnit: {},
      dictList: [],
      radioStatus: null, // 1是;2否
      queryParams: {
        pageSize: '10',
        pageNum: 1,
        company: null,
        pushMp: null,
        pushMpFlag: null,
        pushOfficialWebsite: null,
        pushOfficialWebsiteFlag: null
      },
      radioOptions: [
        { value: 1, label: '是' },
        { value: 2, label: '否' }
      ],
      typeOptions: [
        { value: 1, label: '企业执照' },
        { value: 2, label: '技术成果' },
        { value: 3, label: '成功案例' }
      ],
      columns: [
        {
          field: 'sort',
          title: '排序'
        },
        {
          field: 'title',
          title: '标题'
        },
        // {
        //   field: 'content',
        //   title: '内容'
        // },
        {
          title: '缩略图',
          width: 100,
          type: 'photoPreview',
          payload: {
            field: 'thumbnail'
          }
        },
        {
          field: 'type',
          title: '类型'
        },
        {
          field: 'pushMp',
          title: '是否推送公众号'
        },
        {
          field: 'pushMpFlag',
          title: '是否启用公众号'
        },

        {
          field: 'pushOfficialWebsite',
          title: '是否推官网'
        },
        {
          field: 'pushOfficialWebsiteFlag',
          title: '是否启用官网'
        },
        // {
        //   title: '公众号地址',
        //   type: 'richText',
        //   payload: {
        //     field: 'mpUrl'
        //   }
        // },
        // {
        //   title: '状态',
        //   type: 'switch',
        //   payload: {
        //     field: 'deactive',
        //     change: (row) => this.changeUnitState(row)
        //   }
        // },
        {
          title: '操作',
          width: '160',
          type: 'btn',
          payload: [
            {
              name: '编辑',
              type: 'primary',
              click: (row) => {
                console.log('编辑', row)
                // this.editUnit = JSON.parse(JSON.stringify(row))
                // // 显示弹框
                // this.editState = true
                this.$router.push({
                  path: '/qualificationses/Create',
                  query: { id: row.id }
                })
              }
            },
            {
              name: '删除',
              type: 'danger',
              click: (row) => {
                console.log('删除', row)
                this.deleteFn(row)
              }
            }
          ]
        }
      ]
    }
  },
  methods: {
    handleSizeChange(val) {
      this.queryParams.pageSize = val
      this.getDictList()
    },
    handleCurrentChange(val) {
      this.queryParams.pageNum = val
      this.getDictList()
    },
    // 列表
    getDictList() {
      // this.$loading({
      //   text: '查询中'
      // })

      quaList(this.queryParams).then((res) => {
        if (res.code == 200) {
          // this.$loading().close()

          let dictArr = res.data.records
          this.total = res.data.total
          dictArr.forEach((item) => {
            item.pushMp = Number(item.pushMp) === 1 ? '是' : '否'
            item.pushMpFlag = Number(item.pushMpFlag) === 1 ? '是' : '否'
            item.pushOfficialWebsite =
              Number(item.pushOfficialWebsite) === 1 ? '是' : '否'
            item.pushOfficialWebsiteFlag =
              Number(item.pushOfficialWebsiteFlag) === 1 ? '是' : '否'
            item.type =
              Number(item.type) === 1
                ? '企业执照'
                : Number(item.type) === 2
                ? '技术成果'
                : Number(item.type) === 3
                ? '成功案例'
                : ''
          })
          this.dictList = dictArr
        }
        // else {
        //   this.$loading().close()
        // }
      })
    },

    // 删除
    deleteFn(row) {
      this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let delparams = {
            id: row.id
          }
          deleteQua(delparams).then((res) => {
            console.log(res, '删除')
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.getDictList()
            } else {
              this.$message({
                type: 'error',
                message: '删除失败!'
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },

    // 模糊查询
    dictSearch() {
      this.queryParams.pageNum = 1
      this.getDictList()
    },
    // radio选择
    radioChange(el, type) {
      console.log(el, '当前选择')
      this.queryParams.pageNum = 1
      this.queryParams[type] = el
      this.getDictList()
    }
  },
  mounted() {
    this.getDictList()
  }
}
</script>

<style></style>
